if (!customElements.get('slide-show')) {
  class SlideShow extends HTMLElement {
    constructor() {
      super();
      const slideshow = this;
      const {
        dataset: { dots, autoplay, align, fade },
      } = slideshow;
      
      let parent_section = slideshow.closest('.shopify-section'),
          slideshow_slides = [...slideshow.querySelectorAll('.carousel__slide')],
          autoplayInterval = autoplay === 'false' ? false : parseInt(autoplay, 10),
          prev_button = slideshow.querySelector('.flickity-prev'),
          next_button = slideshow.querySelector('.flickity-next'),
          header = document.querySelector('theme-header'),
          custom_dots = slideshow.querySelector('.flickity-custom-dots'),
          custom_navigation = slideshow.querySelector('.flickity-custom-navigation'),
          autoplay_progress = slideshow.querySelector('.slideshow--autoplay-progress'),
          progress_bar = slideshow.parentNode.querySelector('.flickity-progress--bar'),
          animations = [],
          animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined',
          selectedIndex = 0,
          args = {
            wrapAround: false,
            dragThreshold: 100,
            freeScroll: true,
            cellAlign: align === 'center' ? 'center' : 'left',
            pageDots: dots === 'true',
            contain: true,
            fade: fade === 'true',
            autoPlay: autoplayInterval,
            prevNextButtons: false,
            cellSelector: '.carousel__slide',
            on: {}
          };

      this.paused = false;
      if (custom_dots) args.pageDots = false;

      if (slideshow.classList.contains('image-with-text-slideshow--content')) {
        let main_slideshow = slideshow.parentNode.querySelector('.image-with-text-slideshow--image');
        args.draggable = false;
        args.asNavFor = main_slideshow;
      }

      // Additional logic for specific slideshow classes
      this.setupSlideshowLogic(slideshow, args, slideshow_slides, animations, autoplay_progress, animations_enabled);

      // Initialize Flickity
      const flkty = new Flickity(slideshow, args);
      this.selectedIndex = flkty.selectedIndex;
      slideshow.dataset.initiated = true;

      // Setup buttons
      this.setupButtons(flkty, prev_button, next_button);

      // Shopify Design Mode Handling
      if (Shopify.designMode) {
        slideshow.addEventListener('shopify:block:select', (event) => {
          let index = slideshow_slides.indexOf(event.target);
          flkty.select(index);
        });
      }
    }

    setupSlideshowLogic(slideshow, args, slideshow_slides, animations, autoplay_progress, animations_enabled) {
      // Handle specific class-based logic
      if (slideshow.classList.contains('main-slideshow') && animations_enabled) {
        slideshow.prepareAnimations(slideshow, animations);
        args.on.ready = this.setupMainSlideshow(slideshow, autoplay_progress, animations, animations_enabled);
      }
      // Additional class-based logic can be added here...
    }

    setupMainSlideshow(slideshow, autoplay_progress, animations, animations_enabled) {
      return function() {
        const flkty = this;
        let video_container = flkty.cells[0].element.querySelector('.slideshow__slide-video-bg');
        
        // Handle video play logic
        if (video_container) {
          let video = video_container.querySelector('iframe') || video_container.querySelector('video');
          if (video) video.onloadstart = () => slideshow.videoPlay(video_container);
        }

        // Handle autoplay progress
        if (autoplay_progress && animations_enabled) {
          slideshow.setupAutoplayProgress(slideshow);
        }
      };
    }

    setupAutoplayProgress(slideshow) {
      slideshow.autoPlayProgressTL = gsap.timeline({ inherit: false })
        .fromTo(slideshow.querySelector('.thb-slideshow-progress--svg circle'), {
          drawSVG: 0
        }, {
          duration: parseInt(slideshow.dataset.autoplay, 10) / 1000,
          ease: 'none',
          drawSVG: true
        });

      slideshow.addEventListener('mouseenter', () => slideshow.autoPlayProgressTL.pause().progress(0));
      slideshow.addEventListener('mouseleave', () => slideshow.autoPlayProgressTL.play());
    }

    setupButtons(flkty, prev_button, next_button) {
      if (prev_button) {
        prev_button.addEventListener('click', () => flkty.previous());
        prev_button.addEventListener('keyup', () => flkty.previous());
      }
      if (next_button) {
        next_button.addEventListener('click', () => flkty.next());
        next_button.addEventListener('keyup', () => flkty.next());
      }
    }

    videoPause(video_container) {
      setTimeout(() => video_container.querySelector('video').pause(), 10);
    }

    videoPlay(video_container) {
      setTimeout(() => video_container.querySelector('video').play(), 10);
    }

    prepareAnimations(slideshow, animations) {
      if (!slideshow.dataset.animationsReady) {
        // GSAP animation setup (unchanged)
        slideshow.dataset.animationsReady = true;
      }
    }
  }

  customElements.define('slide-show', SlideShow);
}
